'use client'

import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { CalendarDays } from 'lucide-react'
import { VideoButton } from './VideoButton'
import { ScreenshotZoom } from './ScreenshotZoom'
import { CheckMark } from './CheckMark'

// Radio button SVGs - commented out for now
// function RadioSelected() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
//       <circle cx="13" cy="13" r="12" stroke="currentColor" strokeWidth="2" fill="none"/>
//       <circle cx="13" cy="13" r="7" fill="currentColor"/>
//     </svg>
//   )
// }

// function RadioUnselected() {
//   return (
//     <svg width="24" height="24" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" className="shrink-0">
//       <circle cx="13" cy="13" r="12" stroke="currentColor" strokeWidth="2" fill="none"/>
//     </svg>
//   )
// }

// type CalendarView = 'week' | '3day' | 'day' | 'month'

// const viewImages: Record<CalendarView, string> = {
//   week: '/images/feature-calendar-week.png',
//   '3day': '/images/feature-calendar-3-day.png',
//   day: '/images/feature-calendar-day.png',
//   month: '/images/feature-calendar-month.png',
// }

interface FeatureCalendarProps {
  hideVideoButton?: boolean
}

const BULLET_KEYS = ['bullet1', 'bullet2', 'bullet3', 'bullet4', 'bullet5', 'bullet6', 'bullet7', 'bullet8', 'bullet9'] as const

export function FeatureCalendar({ hideVideoButton }: FeatureCalendarProps = {}) {
  const t = useTranslations('features.calendar')
  return (
    <div className="flex flex-col gap-[20px]">
      {/* Main feature row */}
      <div className="flex flex-wrap gap-[16px] items-start">
        {/* Phone screenshot (clickable) */}
        <ScreenshotZoom src="/images/feature-calendars.png" alt={t('imageAlt')} />

        {/* Content */}
        <div className="flex flex-col gap-[6px] flex-1 min-w-0 break-words hyphens-auto">
          {/* Icon */}
          <div className="w-[24px] h-[24px]">
            <CalendarDays size={24} strokeWidth={2} className="text-[#6B8E6B]" />
          </div>

          {/* Text */}
          <div className="flex flex-col gap-[4px] pt-[2px]">
            <Link href="/features/shared-calendar" className="text-xl font-bold">{t('title')}</Link>
            <p className="text-l">
              {t('desc')}
            </p>
          </div>

          {/* Video button */}
          {!hideVideoButton && <VideoButton videoId="calendar" className="mt-[8px]" />}

          {/* Zoom button */}

          {/* Radio group - commented out for now */}
          {/* <div className="flex flex-col">
            <button
              onClick={() => setView('week')}
              className="flex items-center gap-[10px] h-[44px] cursor-pointer outline-none"
            >
              {view === 'week' ? <RadioSelected /> : <RadioUnselected />}
              <span className="text-l">Week</span>
            </button>

            <button
              onClick={() => setView('3day')}
              className="flex items-center gap-[10px] h-[44px] cursor-pointer outline-none"
            >
              {view === '3day' ? <RadioSelected /> : <RadioUnselected />}
              <span className="text-l">3 Day</span>
            </button>

            <button
              onClick={() => setView('day')}
              className="flex items-center gap-[10px] h-[44px] cursor-pointer outline-none"
            >
              {view === 'day' ? <RadioSelected /> : <RadioUnselected />}
              <span className="text-l">Day</span>
            </button>

            <button
              onClick={() => setView('month')}
              className="flex items-center gap-[10px] h-[44px] cursor-pointer outline-none"
            >
              {view === 'month' ? <RadioSelected /> : <RadioUnselected />}
              <span className="text-l">Month</span>
            </button>
          </div> */}
        </div>
      </div>

      {/* Checklist */}
      <div className="flex flex-col gap-[20px] mt-[6px]">
        {BULLET_KEYS.map((key) => (
          <div key={key} className="flex gap-[12px] items-start">
            <div className="shrink-0">
              <CheckMark size={28} color="#6B8E6B" />
            </div>
            <p className="text-l">
              {t.rich(key, { b: (chunks) => <strong>{chunks}</strong> })}
            </p>
          </div>
        ))}
      </div>
    </div>
  )
}
